import { render } from "./MnDash.vue?vue&type=template&id=21735844"
import script from "./MnDash.vue?vue&type=script&lang=js"
export * from "./MnDash.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__